module.exports = __webpack_public_path__ + "static/spinner-position-do-ca910d04cca5f195999a696378fd29b6.png";